import React from "react";
import { InlineMath } from "react-katex";
import { M, closed, fr, product } from "./BasicCatalogEngine";
import MaturaDataTable from "./MaturaDataTable";

const original = [2,3,4,4,4,3,2,5,5,4];
const weights = [[1,2,3],[1,2,4],[1,3,4],[2,3,4],[2,3,5],[2,4,5],[3,4,5]];
const grades = product(Array(7).fill([3,4,5]));
const numerator = ([a,b,c,...g]) => a*(g[0]+g[1]+g[2])+b*(g[3]+g[4])+c*(g[5]+g[6]);
const denominator = ([a,b,c]) => 3*a+2*b+2*c;
export const decimalCents = cents => cents%100===0 ? String(cents/100) : (cents/100).toFixed(2).replace(".","{,}");

const pool = weights.flatMap(w => {
  const eligible = grades.filter(g => new Set(g).size===3 && numerator([...w,...g])*100%denominator(w)===0);
  // Spread selection across the eligible grade profiles instead of taking the first few.
  return Array.from({length:8},(_,i)=>({values:[...w,...eligible[Math.floor(i*(eligible.length-1)/7)]]}));
});
pool.unshift({values:original});

function build(values) {
  // Older saved attempts stored only weights. Resolve those to a valid profile.
  const v = values.length===3
    ? (values.every((w,i)=>w===original[i]) ? original : pool.find(p=>p.values.slice(0,3).every((w,i)=>w===values[i]))?.values || original)
    : values;
  const [a,b,c,...g]=v, n=numerator(v), d=denominator(v), cents=n*100/d;
  if (!Number.isInteger(cents) || !(a<b&&b<c)) throw new Error("Invalid weighted grade configuration");
  const isOriginal=v.every((value,i)=>value===original[i]);
  const options=(isOriginal?[385,390,395,400]:[cents-10,cents,cents+5,cents+10]).map(decimalCents);
  const math=value=><InlineMath math={String(value)}/>;
  return closed(<><p>Wykładowca oblicza średnie ważone ocen: kartkówka ma wagę {math(a)}, projekt {math(b)}, aktywność {math(c)}. Karolina otrzymała oceny:</p>
    <MaturaDataTable label="Oceny Karoliny"><thead><tr><th scope="colgroup" colSpan={3}>Kartkówki</th><th scope="colgroup" colSpan={2}>Projekty</th><th scope="colgroup" colSpan={2}>Aktywność</th></tr></thead><tbody><tr>{g.map((grade,i)=><td key={i}>{math(grade)}</td>)}</tr></tbody></MaturaDataTable>
    <p>Średnia ważona jest równa</p></>,options,isOriginal?2:1,
    <><M>{`${fr(`${a}(${g.slice(0,3).join("+")})+${b}(${g.slice(3,5).join("+")})+${c}(${g.slice(5).join("+")})`,`3\\cdot${a}+2\\cdot${b}+2\\cdot${c}`)}=${fr(n,d)}=${decimalCents(cents)}`}</M><p>Wagę uwzględniamy osobno dla każdej oceny.</p></>);
}

export const weightedGradesDefinition = {points:1,code3:"9.3.1",family:"WeightedGradesGroupedTable",original,pool,build};
